export default "__VITE_ASSET__UKf2SEJP__"